import styled from 'styled-components'

const Spacing = styled.div`
  ${({ margin }) => margin.b && `margin-bottom: ${margin.b * 8}px`};
  ${({ margin }) => margin.t && `margin-top: ${margin.t * 8}px`};
  ${({ margin }) => margin.l && `margin-left: ${margin.l * 8}px`};
  ${({ margin }) => margin.r && `margin-right: ${margin.r * 8}px`};
  ${({ padding }) => padding.b && `padding-bottom: ${padding.b * 8}px`};
  ${({ padding }) => padding.t && `padding-top: ${padding.t * 8}px`};
  ${({ padding }) => padding.l && `padding-left: ${padding.l * 8}px`};
  ${({ padding }) => padding.r && `padding-right: ${padding.r * 8}px`};
`

Spacing.defaultProps = {
  margin: {},
  padding: {},
}

export default Spacing
